// QuotInfoRepo - 견적서 출력
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useAuth } from '../../../../../contexts/auth';
import { PagingGrid as MainGrid, PagingGrid as SubsGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { CommCol, DateCol, DeciCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { fwUtil } from '../../../../script/util';
import { FwAppLoader } from '../../../../script/components/load-panel/load-panel';

export default function QuotInfoRepo(props) {
    const {
        acce, gubu, cata, catb, code,
        mainTitle, mainRole,
        subsTitle, subsRole,
    } = props;

    // api
    const mainSearchApi = `${acce}/${gubu}/${cata}/${catb}/report/header/search`;  // 메인 조회 api
    const mainReportApi = `${acce}/${gubu}/${cata}/${catb}/report/creat/pdf`;      // 메인 보고서 api
    const subsSearchApi = `${acce}/${gubu}/${cata}/${catb}/report/detail/search`;  // 서브 조회 api

    // 시스템
    const [loading, setLoading] = useState(true);
    // 권한
    const { authCheck } = useAuth();
    const [authList, setAuthList] = useState([]);
    // 그리드
    const gridSize = 'dual';
    const mainKey = ['docu_numb', 'docu_revi'];
    const subsKey = ['docu_numb', 'docu_seri']; 

    const mainGridRef = useRef(null);
    const [mainGridData, setMainGridData] = useState([]);
    const mainGridDataUpdate = useCallback((e) => setMainGridData(e), []);
    const subsGridRef = useRef(null);
    const [subsGridData, setSubsGridData] = useState([]);
    const subsGridDataUpdate = useCallback((e) => setSubsGridData(e), []);

    // 검색 조건
    const [dateValue, setDateValue] = useState(fwUtil.date.getsText.range());
    const dateValueChange = useCallback((e) => { setDateValue([e.value[0], e.value[1]]) }, []);
    const [duraYesn, setDuraYesn] = useState(true);
    const duraYesnChange = useCallback((e) => { setDuraYesn(e.value) }, []);
    const [serchData, setSerchData] = useState({ docuNumb: "", custName: "", prjtName: "" });
    const serchDataChange = useCallback((name, value) => {
        setSerchData((prevData) => ({ ...prevData, [name]: value }));
    }, []);

    // 접근 권한 조회 및 권한 상태값 설정
    useEffect(() => {
        authCheck(setLoading, setAuthList, gubu, code);
    }, [authCheck, setLoading, setAuthList, gubu, code]);

    // 조회
    const mainHandleSearch = useCallback(async () => {
        const sendData = {
            start: dateValue[0], compl: dateValue[1], duraYesn: duraYesn,
            docuNumb: serchData.docuNumb, custName: serchData.custName, prjtName: serchData.prjtName,
        };
        await fwUtil.apis.search(mainSearchApi, sendData, mainGridDataUpdate, mainGridRef, null);
        const mainRowKey = fwUtil.grid.get.sKey(mainGridRef);
        if (mainRowKey) {
            const sendData = { docuNumb: (mainRowKey.docu_numb + mainRowKey.docu_revi) };
            await fwUtil.apis.search(subsSearchApi, sendData, subsGridDataUpdate, subsGridRef);
        }
    }, [dateValue, duraYesn, serchData, mainSearchApi, mainGridRef, mainGridDataUpdate, subsSearchApi, subsGridDataUpdate]);

    const subsHandleSearch = useCallback(async () => {
        const mainRowKey = fwUtil.grid.get.sKey(mainGridRef);
        if (mainRowKey) {
            const sendData = { docuNumb: (mainRowKey.docu_numb + mainRowKey.docu_revi) };
            await fwUtil.apis.search(subsSearchApi, sendData, subsGridDataUpdate, subsGridRef);
        }
    }, [subsSearchApi, subsGridRef, subsGridDataUpdate]);

    const mainGridClick = useCallback(({ key }) => {
        if (key) { subsHandleSearch(); }
    }, [subsHandleSearch]);

    useEffect(() => {
        mainHandleSearch();
    }, [mainHandleSearch]);

    const onReportClick = useCallback(async () => {
        const seleKey = fwUtil.grid.get.mKey(mainGridRef);
        if (!seleKey) {
            fwUtil.aler.toast.nsWarn();
            return;
        }
        try {
            setLoading(true);
            const indxList = [];
            for(let i = 0; i < seleKey.length; i++) {
                const docu_numb = seleKey[i].docu_numb;
                const docu_revi = seleKey[i].docu_revi;
                indxList.push((docu_numb + docu_revi));
            }
            const sendData = { indeKeys: indxList };
            console.log('quot.sendData:', sendData);
            const url = await fwUtil.data.report(mainReportApi, sendData);
            if (!url) {
                return;
            }
            window.open(url, '_blank');
        } catch (error) {
            console.log('reportData.error === ', error);
            fwUtil.aler.toast.s1Erro();
        } finally {
            setLoading(false);
        }
        return;
    }, [mainReportApi]);

    // 추가 툴바 아이템
    const toolbarItems = useMemo(() => [
        { type: 'text', locate: 'before', caption: '견적번호', value: serchData.docuNumb, valueChange: (e) => serchDataChange('docuNumb', e), search: mainHandleSearch },
        { type: 'text', locate: 'before', caption: '고객명', value: serchData.custName, valueChange: (e) => serchDataChange('custName', e), search: mainHandleSearch },
        { type: 'text', locate: 'before', caption: '공사명', value: serchData.prjtName, valueChange: (e) => serchDataChange('prjtName', e), search: mainHandleSearch },
        { type: 'btns', locate: 'after', icon: 'textdocument', text: '견적서', onClick: onReportClick, disabled: authList.auth_dnlo === 0 },
        { type: 'btns', locate: 'before', icon: 'search', text: '검색', onClick: mainHandleSearch },
    ], [authList, serchData, serchDataChange, mainHandleSearch, onReportClick]);

    return (
        <div className='fw-grid-page fw-flex-box col'>
            <FwAppLoader loading={loading} />
            <MainGrid
                title={mainTitle}
                role={mainRole}
                gridSize={gridSize}
                mainKey={mainKey}
                gridRef={mainGridRef}
                gridDataSource={mainGridData}
                dateValue={dateValue}
                dateValueChange={dateValueChange}
                duraYesn={duraYesn}
                duraYesnChange={duraYesnChange}
                onRowClick={mainGridClick}
                exp={{ disabled: authList.auth_dnlo === 0 }}
                toolbar={{ default: true, items: toolbarItems }}
                selection={'single'}
            >
                {CommCol({ dataField: "docu_numb", caption: "견적서번호" })}
                {CommCol({ dataField: "docu_revi", caption: "REV.NO" })}
                {CommCol({ dataField: "item_coun", caption: "품목수" })}
                {CommCol({ dataField: "quot_gubu", caption: "상태" })}
                {CommCol({ dataField: "cust_name", caption: "고객명" })}
                {CommCol({ dataField: "prjt_name", caption: "공사명" })}
                {CommCol({ dataField: "issu_date", caption: "견적일자" })}
                {DeciCol({ dataField: "quot_kwon", caption: "견적금액" })}
                {CommCol({ dataField: "cust_damd", caption: "담당자" })}
                {CommCol({ dataField: "cust_posi", caption: "담당직위" })}
                {CommCol({ dataField: "cust_tels", caption: "전화번호" })}
                {CommCol({ dataField: "quot_remk", caption: "특이사항" })}
            </MainGrid>
            <SubsGrid
                title={subsTitle}
                role={subsRole}
                gridSize={gridSize}
                mainKey={subsKey}
                gridRef={subsGridRef}
                gridDataSource={subsGridData}
                exp={{ disabled: authList.auth_dnlo === 0 }}
                toolbar={{ default: false }}
                selection={'single'}
            >
                {CommCol({ dataField: "item_code", caption: "제품코드" })}
                {CommCol({ dataField: "item_name", caption: "제품명" })}
                {CommCol({ dataField: "desc_size", caption: "규격" })}
                {DeciCol({ dataField: "item_qtys", caption: "수량" })}
                {CommCol({ dataField: "item_quni", caption: "단위" })}
                {DeciCol({ dataField: "item_cwon", caption: "단가" })}
                {DeciCol({ dataField: "subs_kwon", caption: "금액" })}
                {CommCol({ dataField: "item_remk", caption: "비고" })}
                {CommCol({ dataField: "user_name", caption: "작성자" })}
                {DateCol({ dataField: "user_date", caption: "작성일" })}
            </SubsGrid>
        </div>
    );
};